import gql from 'graphql-tag';
import {
  channelInfo,
  commentInfo,
  discussionInfo,
  getChannelId,
  getDiscussionId,
} from '@/store/forumAPI/utils/forum-fields';

export const channelInfoByIdQuery = gql`
  query channelInfoByIdQuery($channelId: Int!) {
    channelsByIds(ids: [$channelId], withDiscussions: true) {
      ${channelInfo}

      discussions {
        ${discussionInfo}

        comments {
          ${commentInfo}
        }
      }
    }
  }
`;

export const paginatedChannelInfoByIdQuery = gql`
  query paginatedChannelInfoByIdQuery($channelId: Int!, $first: Int, $skip: Int, $mostRecentFirst: Boolean) {
    paginatedDiscussions(where: [{ channel: $channelId }], mostRecentFirst: $mostRecentFirst, first: $first, skip: $skip) {
      discussions {
        ${discussionInfo}
        ${getChannelId}

        comments {
          ${commentInfo}
          ${getDiscussionId}
        }
      }
      totalCount
    }
  }
`;
